import { twMerge } from 'tailwind-merge';
import type { OrderStatusId } from '@witmetrics/utils';
import { ORDER_STATUSES } from '@witmetrics/utils/constants';
import { classes, getStatusColors } from './utils';

export type OrderStatusChipProps = {
  className?: string;
  labelClassName?: string;
  orderStatusId: OrderStatusId;
};

export default function OrderStatusChip({
  className,
  orderStatusId,
}: OrderStatusChipProps) {
  const status = Object.values(ORDER_STATUSES).find(
    (s) => s.id === orderStatusId
  )!;
  return (
    <span
      className={twMerge(
        classes.label,
        getStatusColors(orderStatusId),
        className
      )}>
      {status.label}
    </span>
  );
}
